import React, {
  createContext,
  useEffect,
  useState,
  useRef,
  useContext,
} from "react";
import { SupportedNetwork } from "@cat-protocol/cat-sdk";
import { WalletConnector, ConnectedAccount } from "./types";
import { ChainStats, getFeeRate } from "./api";

export interface AppContextProps extends Partial<ChainStats> {
  network: SupportedNetwork;
  connected: () => boolean;
  setNetwork: React.Dispatch<React.SetStateAction<SupportedNetwork>>;

  connectedWallet?: string;
  setConnectedWallet: React.Dispatch<React.SetStateAction<string | undefined>>;

  connectedAccount?: ConnectedAccount;
  setConnectedAccount: React.Dispatch<
    React.SetStateAction<ConnectedAccount | undefined>
  >;

  connectorRef: React.RefObject<WalletConnector | null>;

  feeRate: number;
  setFeeRate: React.Dispatch<React.SetStateAction<number>>;
}

export const AppContext = createContext<AppContextProps | undefined>(undefined);

interface AppProviderProps {
  children: React.ReactNode;
}

export const AppProvider = (props: AppProviderProps) => {
  const { children } = props;

  const connectorRef = useRef<WalletConnector>(null);

  const networkInUrl = new URLSearchParams(window.location.search).get(
    "network"
  );
  // TODO: switch default to Mainnet after runes launching
  const [network, setNetwork] = useState<SupportedNetwork>(
    networkInUrl === "btc-signet" || networkInUrl === "fractal-testnet"
      ? networkInUrl
      : "fractal-mainnet"
  );

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [chainStats, _] = useState<ChainStats | null>(null);
  const [connectedWallet, setConnectedWallet] = useState<string | undefined>();
  const [connectedAccount, setConnectedAccount] = useState<
    ConnectedAccount | undefined
  >();
  const [feeRate, setFeeRate] = useState<number>(1);

  const connected = () => {
    return connectedAccount !== null && connectedAccount !== undefined;
  };


  useEffect(() => {
    getFeeRate(network).then((rate) => {
      console.log("feeRate", rate);
      setFeeRate(rate);
    }
    );
  }, [network]);

  return (
    <AppContext.Provider
      value={{
        ...chainStats,
        network,
        setNetwork,
        connectedAccount,
        setConnectedAccount,
        connectedWallet,
        setConnectedWallet,
        feeRate,
        setFeeRate,
        connected,
        connectorRef,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppProvider = (): AppContextProps => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useAppProvider must be used within an AppProvider");
  }
  return context;
};
